<h1 mat-dialog-title>Histórico de Pagamentos</h1>
<div mat-dialog-content class="mat-body-2">
  <ul>
    <li *ngFor="let item of data.history">
        {{ item.created_at ? (item.created_at | date: 'dd/MM/yyyy') : 'N/A' }} - {{ item.message }}
    </li>
  </ul>
</div>
<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" (click)="close()">Fechar</button>
</div>
